(function () {
    'use strict';

    angular.module("imApp").factory("languagesService", [function () {
        let service = {};

        return service;
    }]);
})();
